import { Tracker } from '@reverbdotcom/discovery-ui';

let initialServerRenderComplete = false;

export default (location) => {
  if (initialServerRenderComplete) {
    // Initial pageView (including non-client routed pages) comes from error_logger.js init
    Tracker.pageView(location);

    if (window.ga !== undefined) {
      const urlWithParams = `${location.pathname}${location.search}`;
      window.ga('set', 'page', urlWithParams);
      window.ga('send', 'pageview');
    }
  }

  initialServerRenderComplete = true;
};



// WEBPACK FOOTER //
// ./javascripts/components/track_page_view.js